/**
 * This helper transforms image URL from plus and editorial wallpapers,
 * to a URL that fits best for the current window size.
 * Unfortunately, backend responses can be given in different flavors,
 * that's why we have so many conditionals and loops...
 */
import includes from 'lodash/includes';
import last from 'lodash/last';

const optimizedSizes = [
  {
    size: 'Small',
    width: 1280,
    height: 800,
  },
  {
    size: 'Medium',
    width: 1680,
    height: 1050,
  },
  {
    size: 'Large',
    width: 1920,
    height: 1200,
  },
];

function getOptimizedResolution() {
  for (let i = 0; i < optimizedSizes.length; i++) {
    const resolution = optimizedSizes[i];
    // Our option is greater than the window's width, use it
    if (window.innerWidth <= resolution.width) {
      return resolution;
    }
  }

  // We default to the largest image size.
  return last(optimizedSizes);
}

export function optimizePath(creative) {
  const path = creative.src || creative.asset_url;
  const resolution = getOptimizedResolution();

  // Does it support imagevise urls?
  const imageViseUrl = `resizedSrc${resolution.size}`;
  if (creative[imageViseUrl]) {
    return creative[imageViseUrl];
  }

  // If the path contains [SIZE] we'll replace that with the dimensions.
  if (includes(path, '[SIZE]')) {
    return path.replace('[SIZE]', `${resolution.width}x${resolution.height}`);
  }

  // If nothing matches, just return the regular path.
  return path;
}
